import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useGetDiplomaDateQuery,useGetDiplomaFindLocationQuery, useGetDiplomaFindSlotQuery, useDiplomaSaveAppointmentMutation } from "../../Services/api";
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css'; // Import the date picker styles
import { useParams } from "react-router-dom";

export default function Login() {
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedLoc, setSelectedLoc] = useState(null);
    const [selectedType, setSelectedType] = useState(null);

    const { branch } = useParams();

    const [formShow, setFormShow] = useState(true);
     const handleDateChange = (e) => {
        const value = e.target.value; // This is a string like "2025-08-10"
        if (!value) {
            setSelectedDate("");
            return;
        } 
        const dateObj = new Date(value); // Convert string to Date object
        const utcDate = new Date(Date.UTC(
            dateObj.getFullYear(),
            dateObj.getMonth(),
            dateObj.getDate()
        ));
        const formattedDate = utcDate.toISOString().split('T')[0];
        setSelectedDate(formattedDate);
    };
    const handleLocationChange = (e) => {
        setSelectedLoc(e.target.value);
    };
    const handleTypeChange = (e) => {
        var type = 1;
        if (e.target.value !== 'QHSE Office') {
            type = 1;
        }
        else {
            type = 0;
        }
        setSelectedType(type);
    };
    const {
        data: location,
    } = useGetDiplomaFindLocationQuery({ params: selectedDate });
    const {
        data: getDiplomaDate,
    } = useGetDiplomaDateQuery({ params: {branch,selectedDate} });
    
    const slotParams = selectedDate + "/" + selectedLoc + "/" + selectedType;
    const {
        data: slot,
    } = useGetDiplomaFindSlotQuery({ params: slotParams });
    
    const validationSchema = Yup.object().shape({
        //   apointmentDate: Yup.string().required("Apointment date is required"),
        email: Yup.string().required("Email is required").email("Email is invalid"),
        locId: Yup.string().required("Location is required"),
        location_type: Yup.string().required("Location type is required"),
        timeSlot: Yup.string().required("Time Slot is required"),
        reasonId: Yup.string().required("Reason is required"),
        name: Yup.string().required("Name is required"),
        student_number: Yup.string().required("Student number is required"),
        mobile_number: Yup.string().required("Mobile number is required"),

    });
    let defaultValues = { email: "", password: "" };
    const notify = () => '';
    const methods = useForm({
        mode: "onTouched",
        resolver: yupResolver(validationSchema),
        defaultValues,
    });
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = methods;
    const [diplomaSaveAppointment, isLoading] = useDiplomaSaveAppointmentMutation()
    const onSubmit = (values) => {
        values.apointmentDate = selectedDate;
        values.location_type = selectedType;
        if (selectedDate == null) {
            toast.error('Please Select appointment date')
        }
        if (selectedType == null) {
            toast.error('Please Select location type')
        }
         values.branch_id=branch;
        diplomaSaveAppointment({ data: values })
            .unwrap()
            .then((payload) => {
                if (payload.status) {
                    if (payload.data === 0) {
                        toast.error(payload.message)
                    }
                    else {
                        setFormShow(false);
                        toast.success('booked appointment successfully')
                    }
                } else {
                    toast.error(payload.message)
                }
            })
            .catch((error) => {
                toast.error(error.data.message)
            });
        notify();
    };
      const formatDate = (dateString) => {
         const dateObj = new Date(dateString);
        return dateObj.toLocaleDateString("en-US", {
            weekday: "long",  // <-- Adds day name
            year: "numeric",
            month: "long",
            day: "numeric"
        });
    }
    return (
        <>
            <div className="card mb-3">
                <div className="card-body">
                    <div className="pt-4 pb-2">
                        <h5 className="card-title text-center pb-0 fs-4">NEBOSH International Diploma</h5>
                    </div>
                   {
                    formShow ?
                    <form className="row g-3 needs-validation" >
                        <div className="col-4">
                            <label htmlFor="yourUsername" className="form-label">Interview Date</label>
                            <div className="input-group has-validation">
                                {/* <DatePicker
                                    className="form-control"
                                    selected={selectedDate}
                                    onChange={handleDateChange} // Trigger function on date change
                                    dateFormat="yyyy-dd-MM" // Optional: Set date format
                                    placeholderText="Click to select a date" // Placeholder text
                                /> */}
                                <select selected={selectedDate} onChange={handleDateChange} className="form-control" >
                                    <option value="">Select Date</option>
                                    {
                                        getDiplomaDate && getDiplomaDate?.data?.map((item) => {
                                            return (
                                                 <option key={item.id} value={item.start_date}>{item.start_date} -- ({formatDate(item.start_date)})</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                            <span className="text-danger">{errors.apointmentDate?.message}</span>

                        </div>
                        <div className="col-4">
                            <label htmlFor="yourUsername" className="form-label">Location</label>
                            <select   {...register("locId", { onChange: handleLocationChange })} className="form-control" >
                                <option value="">Select Location</option>
                                {
                                    location && location?.data?.getLocation?.map((item) => {
                                        return (
                                            <option key={item.id} value={item.id}>{item.locationname}</option>
                                        )
                                    })
                                }
                            </select>
                            <span className="text-danger">{errors.locId?.message}</span>
                        </div>
                        <div className="col-4">
                            <label htmlFor="yourUsername" className="form-label">Location Type</label><br />

                            <div className="form-check form-check-inline">
                                <input
                                    {...register("location_type", { onChange: handleTypeChange })}
                                    className="form-check-input interview_type"
                                    type="radio"
                                    id="ghse"
                                    value="QHSE OFFICE"
                                />
                                <label className="form-check-label" htmlFor="location_type">QHSE Office</label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input
                                    className="form-check-input interview_type"
                                    type="radio"
                                    {...register("location_type", { onChange: handleTypeChange })}
                                    id="zoom"
                                    value="ZOOM CALL"
                                />
                                <label className="form-check-label" htmlFor="zoom">Zoom Call</label>
                            </div>
                        </div>
                        <div className="col-6">
                            <label htmlFor="yourUsername" className="form-label">Select Time slot</label>
                            <div className="input-group has-validation">

                                <select   {...register("timeSlot")} className="form-control" >
                                    <option value="">Select Time Slot</option>
                                    {
                                        slot?.data !==0 && slot?.data?.map((item) => {
                                            return (
                                                <option key={item.id} value={item.id}>{item.slot}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                            <span className="text-danger">{errors.timeSlot?.message}</span>
                        </div>
                        <div className="col-6">
                            <label htmlFor="yourUsername" className="form-label">Reason</label>
                            <div className="input-group has-validation">
                                <select   {...register("reasonId")} className="form-control" >
                                    <option value="">Select Reason</option>
                                    {
                                        location && location?.data?.getReason?.map((item) => {
                                            return (
                                                <option key={item.id} value={item.id}>{item.reason}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                            <span className="text-danger">{errors.reasonId?.message}</span>
                        </div>
                        <div className="col-6">
                            <label htmlFor="yourUsername" className="form-label">Name</label>
                            <div className="input-group has-validation">
                                <input type="name"  {...register("name")} className="form-control" />
                            </div>
                            <span className="text-danger">{errors.name?.message}</span>
                        </div>
                        <div className="col-6">
                            <label htmlFor="yourUsername" className="form-label">Mobile Number</label>
                            <div className="input-group has-validation">
                                <input type="number"  {...register("mobile_number")} className="form-control" />
                            </div>
                            <span className="text-danger">{errors.mobile_number?.message}</span>
                        </div>
                        <div className="col-6">
                            <label htmlFor="yourUsername" className="form-label">Email </label>
                            <div className="input-group has-validation">
                                <input type="email"  {...register("email")} className="form-control" />
                            </div>
                            <span className="text-danger">{errors.email?.message}</span>
                        </div>
                        <div className="col-6">
                            <label htmlFor="yourUsername" className="form-label">Student Number</label>
                            <div className="input-group has-validation">
                                <input type="text"  {...register("student_number")} className="form-control" />
                            </div>
                            <span className="text-danger">{errors.student_number?.message}</span>
                        </div>

                        <div className="col-3 text-center">
                            {isLoading.status !== 'pending' ?
                                <button type="submit" className="btn btn-warning w-100" onClick={handleSubmit(onSubmit)}> Save</button>
                                :
                                <button className="btn btn-warning w-100" ><div className="spinner-border text-muted"></div></button>
                            }
                        </div>
                        <div className="col-12">
                        </div>
                    </form>
                    :
                    <>
                    <div className="row">
                        <div className="col-2"></div>
                        <div className="col-8">
                            <h3 className="text-center text-success">Appointment Booked Successfully</h3>
                        </div>
                        <div className="col-2"></div>
                    </div>
                        
                    </>
                    }
                </div>
            </div>
        </>
    );
}